import { Fragment } from 'react';

import type { AutoRestartSegment } from './autoRestartView';

export const renderAutoRestartSummary = (segments: readonly AutoRestartSegment[]) =>
  segments.map((segment, index) => (segment.strong ? <strong key={index}>{segment.text}</strong> : <Fragment key={index}>{segment.text}</Fragment>));
